var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"payment-view"}},[_c('v-container',{staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_c('v-row',{staticStyle:{"min-height":"100%"}},[_c('v-col',{attrs:{"cols":"6","offset":"1"}},[_c('FinalPaymentForm')],1),_c('v-col',{attrs:{"cols":"4"}},[_c('CustomerData')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }